/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_PopularInputs */

const en_directory_search_popular = /** @type {(inputs: Directory_Search_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popular`)
};

const pl_directory_search_popular = /** @type {(inputs: Directory_Search_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popularne`)
};

/**
* | output |
* | --- |
* | "Popular" |
*
* @param {Directory_Search_PopularInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_popular = /** @type {((inputs?: Directory_Search_PopularInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_PopularInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_popular(inputs)
	return en_directory_search_popular(inputs)
});